<template>
  <el-row>
    <el-col :span="24">
      <el-card class="box-card">
        <div slot="header" class="clearfix flex justify-between">
          <span>添加审核人员</span>
        </div>
        <el-form label-width="120px">
          <el-form-item label="用户ID">
            <el-input 
              v-model="addAuditUserOtherViewInfo.userId" 
              readonly 
              placeholder="必填，请填写用户ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名称">
            <el-input 
              v-model="addAuditUserOtherViewInfo.userName" 
              readonly 
              placeholder="必填，请填写用户名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核环节" required>
            <el-select 
              v-model="addAuditUserOtherViewInfo.auditLink" 
              placeholder="必填，请选择审核环节"
              style="width:100%"
            >
              <el-option label="部门主管" value="809001"></el-option>
              <el-option label="财务主管" value="809002"></el-option>
              <el-option label="采购人员" value="809003"></el-option>
              <el-option label="投诉处理人员" value="809004"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="流程对象" required>
            <el-select 
              v-model="addAuditUserOtherViewInfo.objCode" 
              placeholder="必填，请选择审核流程"
              style="width:100%"
            >
              <el-option label="采购流程" value="resourceEntry"></el-option>
              <el-option label="出库流程" value="resourceOut"></el-option>
              <el-option label="投诉流程" value="complaint"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'AddAuditUserOtherView',
  props: {
    callBackListener: {
      type: String,
      default: ''
    },
    callBackFunction: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      addAuditUserOtherViewInfo: {
        flowComponent: 'addAuditUserOtherView',
        userId: '',
        userName: '',
        auditLink: '',
        objCode: ''
      }
    }
  },
  watch: {
    addAuditUserOtherViewInfo: {
      deep: true,
      handler() {
        this.saveAddAuditUserOtherInfo()
      }
    }
  },
  methods: {
    clear(staffInfo) {
      this.addAuditUserOtherViewInfo = {
        flowComponent: 'addAuditUserOtherView',
        userId: staffInfo.userId,
        userName: staffInfo.name,
        auditLink: '',
        objCode: ''
      }
    },
    addAuditUserOtherValidate() {
      const rules = {
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' },
          { type: 'number', message: '用户ID必须为数字', trigger: 'blur', transform: value => Number(value) }
        ],
        userName: [
          { required: true, message: '用户名称不能为空', trigger: 'blur' },
          { min: 2, max: 50, message: '用户名称必须在2至50字符之间', trigger: 'blur' }
        ],
        auditLink: [
          { required: true, message: '审核环节不能为空', trigger: 'change' }
        ],
        objCode: [
          { required: true, message: '流程对象不能为空', trigger: 'change' },
          { max: 64, message: '物品库存不能大于64位', trigger: 'blur' }
        ]
      }
      console.log(rules)
      return this.$refs.form ? this.$refs.form.validate() : false
    },
    saveAddAuditUserOtherInfo() {
      if (this.addAuditUserOtherValidate()) {
        this.$emit(this.callBackListener, this.callBackFunction, this.addAuditUserOtherViewInfo)
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>